import type { AnalyticsClient, CookieClient } from '@/scopes/common/domain/types';
import { createLoggedUserEvent } from '@/domain/header/analytics';
import { parseUserCookie } from './parseUserCookie';

interface Dependencies {
  analyticsClient: AnalyticsClient;
  cookieClient: CookieClient;
}

export default function useCases({ analyticsClient, cookieClient }: Dependencies) {
  function reactPageLoaded() {
    const userData = cookieClient.get('user-data');
    const { userId, isLoggedIn } = parseUserCookie(userData);
    analyticsClient.sendEvent(createLoggedUserEvent({ loggedIn: isLoggedIn, userId }));
  }

  return {
    reactPageLoaded,
  };
}
